var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"accueil-eb"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h1',{staticClass:"display-3"},[_vm._v("Espace Relation Client")]),_c('p',[_vm._v("Bienvenue dans l'espace relation client.")])])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }